// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2RvOQ","actionsCol":"EnrolledClinics_actionsCol__QwJN1"};